import { useEffect } from "react";
import PropTypes from "prop-types";

import { usePlayer } from "./hooks";

export default function Playlist({ options }) {
  const player = usePlayer();
  const { source } = options;

  useEffect(() => {
    if (player.setPlaylist && source) {
      player.setPlaylist(source);
    }
  }, [source, player]);

  return null;
}

Playlist.propTypes = {
  options: PropTypes.shape({
    source: PropTypes.string.isRequired,
  }).isRequired,
};
